import { PackageTypeList } from "@/resources/packages/PackageTypeList";

/** Frames — packages of `package_type='frame'` over the unified `/api/packages`. */
export function FrameList() {
  return (
    <PackageTypeList
      resource="frames"
      packageType="frame"
      title="Frames"
      description="Framing packages that shape bets and constrain how work is interpreted."
      emptyMessage="No frames yet."
    />
  );
}

export default FrameList;
